module.exports = __webpack_public_path__ + "img/certo1.050acc60.png";